import { useState, useEffect } from "react";

import { getPrivacyPolicy } from "services/contracts";

import LoaderContractModalWrapper from "components/loader-contract-modal-wrapper";
import Loader from "components/loader";

const PrivacyPolicyContent = () => {
  const [content, setContent] = useState();

  useEffect(() => {
    getPrivacyPolicy().then((data) => {
      const template = data.data.template;
      setContent(template);
    });
  }, []);

  return (
    <>
      {content ? (
        <div dangerouslySetInnerHTML={{ __html: content }} />
      ) : (
        <LoaderContractModalWrapper>
          <Loader />
        </LoaderContractModalWrapper>
      )}
    </>
  );
};

export default PrivacyPolicyContent;
